import { useState, useRef, useEffect } from "react";
import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import Dropdown from "components/forms/Dropdown";
import SelectionItem from "components/forms/SelectionItem";
import DropdownSelection from "components/forms/DropdownSelection";
import ButtonPrimary from "components/buttons/ButtonPrimary";
import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";
import RollingBox from "components/other/RollingBox";
import InputText from "components/forms/InputText";

const MailingListEmailForm = styled.div`
  display: flex;
  flex-direction: column;
`;

const EmailFormText = styled.div`
  margin-top: 45px;
`;

const EmailFormDropdownLine = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const EmailFormDropdownWrap = styled.div`
  position: relative;
  width: 100%;
  max-width: 290px;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const EmailFormEmailSelection = styled.div`
  min-height: 250px;

  display: flex;
  flex-direction: column;
`;

const EmailFormAddEmailButtonWrap = styled.div`
  display: flex;
`;

const EmailSelectionItem = styled.div`
  font-family: "Arial", sans-serif;
`;

const EmailFormSelectButtonWrap = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_LARGE};

  display: flex;
`;

const NewEmailHidingBox = styled.div`
  padding-bottom: 10px;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const NewEmailInputWrap = styled.div`
  width: 100%;
  max-width: 250px;
  margin-top: 5px;
`;

const ButtonWrap = styled.div`
  display: flex;
`;

const Warning = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: ${css.ERROR_RED};
`;

const VerificationCodeInfo = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

export default ({
  emailSelected,
  data,
  emailSelectionOpened,
  toggleEmailSelection,
  onEmailSelect,
  togglenNewEmailForm,
  newEmailFormOpened,
  emailWarning,
  loadingAddEmail,
  emailInput,
  handleEmailInputChange,
  addNewEmail,
  errorMessage,
  codeInputVisible,
  codeInput,
  handleCodeInputChange,
  loadingVerifyCode,
  verifyCode,
  codeWarning,
  selectEmail,
}) => {
  const dropdownRef = useRef();
  const selectionRef = useRef();

  // prepare email selection
  function useSelectionOutsideClick(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          !dropdownRef.current.contains(event.target)
        ) {
          toggleEmailSelection();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useSelectionOutsideClick(selectionRef);

  let optionsList = [];

  data.mailingListEmailFormEmails.map((email) => {
    optionsList.push(
      <SelectionItem
        onClick={() => {
          onEmailSelect(email);
          toggleEmailSelection();
        }}
        key={email}
      >
        <EmailSelectionItem>{email}</EmailSelectionItem>
      </SelectionItem>
    );
  });

  return (
    <MailingListEmailForm>
      <EmailFormText>
        Select the email address that will be used in verification emails sent
        to your leads.
      </EmailFormText>
      <EmailFormEmailSelection>
        <EmailFormDropdownLine>
          <EmailFormDropdownWrap>
            <Dropdown
              onClick={toggleEmailSelection}
              dropdownRef={dropdownRef}
              disabled={newEmailFormOpened}
            >
              {emailSelected}
            </Dropdown>
            {emailSelectionOpened && (
              <DropdownSelection
                width="290px"
                selectionRef={selectionRef}
                top="48px"
              >
                {optionsList}
              </DropdownSelection>
            )}
          </EmailFormDropdownWrap>
          <EmailFormAddEmailButtonWrap>
            <ButtonPrimarySmall onClick={togglenNewEmailForm}>
              {newEmailFormOpened || codeInputVisible ? "Close" : "Add Email"}
            </ButtonPrimarySmall>
          </EmailFormAddEmailButtonWrap>
        </EmailFormDropdownLine>
        <RollingBox>
          {newEmailFormOpened && (
            <NewEmailHidingBox>
              <NewEmailInputWrap>
                <InputText
                  type="email"
                  name="email"
                  value={emailInput}
                  placeholder="Enter new email address"
                  onChange={handleEmailInputChange}
                  maxLength={100}
                  warning={emailWarning}
                  margin="5px 0 0 0"
                />
              </NewEmailInputWrap>
              {emailWarning && (
                <Warning>The email address is missing or incorrect.</Warning>
              )}
              {errorMessage && <Warning>{errorMessage}</Warning>}
              <ButtonWrap>
                <ButtonPrimary disabled={loadingAddEmail} onClick={addNewEmail}>
                  Add Email
                </ButtonPrimary>
              </ButtonWrap>
            </NewEmailHidingBox>
          )}
          {codeInputVisible && (
            <NewEmailHidingBox>
              <VerificationCodeInfo>
                We have sent a verification code to the email address you
                provided. Please confirm the address by entering the code you
                received.
              </VerificationCodeInfo>
              <NewEmailInputWrap>
                <InputText
                  type="text"
                  name="code"
                  value={codeInput}
                  placeholder="Enter verification code"
                  onChange={handleCodeInputChange}
                  maxLength={8}
                  warning={codeWarning}
                  margin="0 0 0 0"
                />
              </NewEmailInputWrap>
              {errorMessage && <Warning>{errorMessage}</Warning>}
              <ButtonWrap>
                <ButtonPrimary
                  disabled={loadingVerifyCode}
                  onClick={verifyCode}
                >
                  Verify
                </ButtonPrimary>
              </ButtonWrap>
            </NewEmailHidingBox>
          )}
        </RollingBox>
      </EmailFormEmailSelection>
      <EmailFormSelectButtonWrap>
        <ButtonPrimary
          disabled={newEmailFormOpened || codeInputVisible}
          onClick={selectEmail}
        >
          Select
        </ButtonPrimary>
      </EmailFormSelectButtonWrap>
    </MailingListEmailForm>
  );
};
